// extracted by mini-css-extract-plugin
export default {"redirect":"Redirect_redirect__YBg1O","redirect__label":"Redirect_redirect__label__tNGOn"};